<template>
    <form v-on:submit.prevent="submit" id="cc-form" class="row m-0 p-0">
        <div class="row np nm">
            <div class="col-12">
                <h3 class="text-center mb-3">Recupere seu acesso</h3>
            </div>
            <div class="col-12 text-center mb-3">
                Digite seu CPF cadastrado abaixo para procurarmos formas de recuperar o
                seu acesso.
            </div>
        </div>
        <div class="row m-0 p-0">
            <div class="col-md-12 mb-3 mt-3">
                <masked-input
                    id="mask_cpf"
                    v-validate="'required|cpf'"
                    type="text"
                    name="cpf"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('cpf') }"
                    v-model="document"
                    :mask="[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/]"
                    v-on:keydown.delete="onDeleteMask"
                    :guide="false"
                    placeholder="000.000.000-00"
                ></masked-input>
                <div class="invalid-feedback">{{ errors.first("cpf") }}</div>
            </div>
        </div>
        <div class="row m-0 p-0">
        <div class="col-12">
            <button v-if="!loading" class="form-control btn-lg btn-success" type="submit">
                CONSULTAR
            </button>
            <button v-else class="form-control btn-success btn-lg d-flex justify-content-center align-items-center" type="button" disabled>
                <div class="spinner-border text-dark" role="status"></div>
            </button>
        </div>
        </div>
    </form>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            document: '',
            loading: false,
        }
    },
    methods: {
        async submit() {
            try {
                this.loading = true
                const document = this.document.replaceAll('.', '').replaceAll('-', '')
                const response = await axios.get(`/account/recover/${document}`)
                this.$emit('success', response.data)
            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        }
    }
})
</script>

<style scoped>
    .np {
        padding: 0px !important;
    }

    .nm {
        margin: 0px !important;
    }

    .form-control {
        font-size: 16px;
    }
    
    .text-justify {
        text-align: justify;
    }
</style>